<template>
  <div class="category-card w-4/12 md:w-5/12" @click="handleClick">
    <a>{{ category.name }}</a>
  </div>
</template>

<script>
import EventBus from "serviceshift-ui/shared/src/lib/event_bus";

export default {
  props: {
    category: {
      type: Object,
      default: null
    }
  },
  methods: {
    handleClick() {
      EventBus.$emit("category-click", this.category);
    }
  }
};
</script>

<style lang="scss" scoped>
.category-card {
  @apply rounded-lg;
  line-height: 1.1;
  background-color: var(--primary-color);
  box-shadow: var(--box-shadow);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px;
  height: 50px;
  font-size: 0.8em;
  width: calc(33.333333% - 10px) !important;
  &:hover {
    background-color: #1155dd;
  }
  a {
    text-decoration: none;
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
}
@media screen and (min-width: 768px) {
  .category-card {
    width: calc(25% - 10px) !important;
  }
}
</style>
